import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { RouterService } from 'src/app/services/router-service.service';
import { map, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserType } from '../models/UserType';

@Injectable({
	providedIn: 'root'
})
export class IsStoreGuard implements CanActivate {

	constructor(private auth: AuthService, private routerService:RouterService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		let notStoreRedirectionRoute : string|undefined = route.data["ifNotStoreRedirectTo"];
		if (this.auth.isLoggedIn()) {
			return this.auth.oUser.pipe(
				map((user:UserType) => {
					if (!user) {
						this.routerService.toLogin(state.url);
						return false;
					}

					if (!user.is_store) {
						if (notStoreRedirectionRoute)
							this.routerService.toUrl(notStoreRedirectionRoute)
						else 
							this.routerService.toHome();
						return false;
					}
					
					return true;
				})
			);
		} else {
			this.routerService.toLogin(state.url);
			return of(false);
		}
	}
}